
import { mapState } from 'vuex'
export default {
    name: 'Theme3SideMenu',
    data() {
        return {
            model: null,
        }
    },
    computed: {
        message() {
            return this.$store.state.player.messages
        },
        ...mapState({
            operationSetting: (state) => state.settings.operationSetting,
        }),
        infoItems() {
            return [
                {
                    icon: 'mdi-account',
                    text: this.tl('myProfile'),
                    key: 'profile',
                    to: '/player/profile',
                },
                {
                    icon: 'mdi-bank',
                    text:
                        ~~this.operationSetting?.reg_flow === 5
                            ? this.tl('walletDetail')
                            : this.tl('bankDetail'),
                    key: 'bank-details',
                    to: '/payment-methods',
                },
                {
                    icon: 'mdi-email-outline',
                    text: this.tl('message'),
                    actions: this.message.total,
                    key: 'messages',
                    to: '/player/messages',
                },
                {
                    icon: 'mdi-history',
                    text: this.tl('history'),
                    key: 'history',
                    to: '/history/transaction',
                },
                {
                    icon: 'mdi-lock',
                    text: this.tl('resetPassword'),
                    key: 'reset-password',
                    to: '/reset-password',
                },
                {
                    icon: 'mdi-account-group-outline',
                    text: this.tl('inviteAndEarn'),
                    key: 'refer-friend',
                    to: '/refer-friend',
                },
                {
                    icon: 'mdi-controller',
                    text: this.tl('gameHistory'),
                    key: 'game-history',
                    to: '/history/game',
                },
            ]
        },
        financeList() {
            return [
                {
                    icon: 'mdi-credit-card-plus-outline',
                    text: this.tl('deposit'),
                    key: 'deposit',
                    to: '/player/deposits',
                },
                {
                    icon: 'mdi-credit-card-minus-outline',
                    text: this.tl('withdrawal'),
                    key: 'withdrawal',
                    to: '/player/withdrawals',
                },
                {
                    icon: 'mdi-hand-coin-outline',
                    text: this.tl('cashier'),
                    key: 'cashier',
                    to: '/cashier',
                },
                {
                    icon: 'mdi-gift-outline',
                    text: this.tl('myBonus'),
                    key: 'myBonus',
                    to: '/my-bonus',
                },
            ]
        },
    },
}
